import { render, staticRenderFns } from "./senior.vue?vue&type=template&id=7f1bbce0&scoped=true&"
import script from "./senior.vue?vue&type=script&lang=js&"
export * from "./senior.vue?vue&type=script&lang=js&"
import style0 from "./senior.vue?vue&type=style&index=0&id=7f1bbce0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1bbce0",
  null
  
)

export default component.exports